module.exports = __webpack_public_path__ + "fonts/Trade-Gothic-Bold.ttf";


//////////////////
// WEBPACK FOOTER
// ./Common/fonts/Trade-Gothic-Bold.ttf
// module id = 25
// module chunks = 0 1 2 3 4 5 6 7